import {
    receive_live_story_content,
    reset_live_story,
} from "../../reducers/LiveStory/reducer";
import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import log from "../../utils/logger/library";
import { HttpError } from "../../utils/errors/http";
import { GqlError } from "../../utils/errors/http";
import { dispatchUpdateApp } from "../Detail/dispatchers";
import {
    getLiveStory,
    getLiveStoryUpdates,
} from "../../fetch/graphql/requests/liveStories/library";
import { getLiveStoryPageJsonLD } from "../../utils/seo/library";
import { createLiveStoryPayload } from "../../reducers/LiveStory/reducer";

export const fetch_live_story_page = (
    sourceId,
    isPreview = false,
    pubDate = null
) => {
    return async (dispatch) => {
        dispatch(reset_live_story());

        try {
            dispatch(start_loading());

            const response = await getLiveStory(sourceId, isPreview, pubDate);

            if (response?.data?.liveStoryPage?.type !== "livestory") {
                log.warn("(fetch_live_story_page) content type not supported!");
                throw new HttpError(404);
            }

            const { liveStoryPage } = response.data;

            liveStoryPage.schema = getLiveStoryPageJsonLD(liveStoryPage);

            dispatch(receive_live_story_content(liveStoryPage));
            dispatch(dispatchUpdateApp(liveStoryPage));
        } catch (error) {
            const gqlError =
                error instanceof Error ? error : new GqlError(error);
            log.error(
                `(fetch_live_story_page) request failed for ${sourceId}`,
                gqlError
            );
            throw gqlError;
        } finally {
            dispatch(set_loading_complete());
        }
    };
};

export const fetch_live_story_updates = async (sourceId, queryArgs) => {
    try {
        const response = await getLiveStoryUpdates(sourceId, queryArgs);
        const liveStoryPayload = createLiveStoryPayload(
            response.data.liveStoryUpdates
        );
        return liveStoryPayload;
    } catch (error) {
        const gqlError = error instanceof Error ? error : new GqlError(error);
        log.error(
            `(fetch_live_story_updates) request failed for ${sourceId}`,
            gqlError
        );
        throw gqlError;
    }
};
